import type { MessagingGetChatMessages200PageAllOfThreeContentItemAllOfSenderBasicInfo } from './messagingGetChatMessages200PageAllOfThreeContentItemAllOfSenderBasicInfo';
import type { MessagingGetChatMessages200PageAllOfThreeContentItemAllOfSenderSocial } from './messagingGetChatMessages200PageAllOfThreeContentItemAllOfSenderSocial';

/**
 * 발신자 정보
 */
export type MessagingGetChatMessages200PageAllOfThreeContentItemAllOfSender = {
  /** 사용자 기본 정보 */
  basicInfo: MessagingGetChatMessages200PageAllOfThreeContentItemAllOfSenderBasicInfo;
  /** 소셜 관계 정보 */
  social?: MessagingGetChatMessages200PageAllOfThreeContentItemAllOfSenderSocial;
};
